import { Badge } from '@e2n/ui';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Qualifikationen({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const { t } = useTranslation();
  const arbeitsbereichNames = rotationsplan.abgeschlosseneStationen
    .filter((station) => station instanceof ArbeitsbereichStation)
    .map((station) => station.arbeitsbereich.name);

  const uniqueNames = [...new Set(arbeitsbereichNames)];

  return (
    <div className="flex gap-1 items-center min-h-5.5">
      <FontAwesomeIcon
        fixedWidth
        icon={faFileCertificate}
        className="text-neutrals-700"
      />
      {rotationsplan.abgeschlosseneStationen.length < 1 ? (
        <div className="text-xs text-neutrals-700">
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.keineQualifikation',
          )}
        </div>
      ) : (
        uniqueNames.map((name, index) => (
          <Badge key={index} variant="outline" type="pill">
            {name}
          </Badge>
        ))
      )}
    </div>
  );
}
